export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1').replace(/\/$/, '');
export const BACKEND_BASE_URL = (process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:5000').replace(/\/$/, '');
export const FRONTEND_BASE_URL = (process.env.REACT_APP_FRONTEND_URL || '').replace(/\/$/, '');

export const appConfig = {
  API_BASE_URL,
  BACKEND_BASE_URL,
  FRONTEND_BASE_URL,
};

export default appConfig;
